<template>
  <div class="transaction">
    <Text
      pattern="body2"
      :weight="500"
      :height="130"
      align="left"
      :textDecoration="value ? 'underline' : 'none'"
    >
      {{ value ? shorten(value) : "the-void" }}
    </Text>
    <img :src="Icon" />
    <!--    <Copy v-if="value" :value="value" />-->
  </div>
</template>

<script setup>
import { Text } from "@/shared/ui";
import Icon from "../assets/arrow-in-circle.svg";
// import Copy from "@/features/Copy/ui/Copy.vue";
import { shorten } from "@/shared/utils/format";

defineProps({
  value: {
    type: String,
    default: "",
  },
});
</script>

<style lang="scss" scoped>
.transaction {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding-right: 27px;
  justify-content: space-between;
}
</style>
